import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'Home',
      redirect: "/Homepage",
    },
    //   // redirect: '/UC'
    // },

    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/404',
      name: '404',
      component: (resolve) => require(['@/views/404'], resolve)
    },
    {
      path: '/Homepage',
      name: 'Homepage',
      component: () => import('../views/Hompage/index.vue')

    },
    //首页信息
    {
      path: '/TownIndex2',
      name: 'TownIndex2',
      component: () =>
        import( /* webpackChunkName: "Town" */ '@/views/TownIndex2/swiper'),
      // redirect: '/Town/List',
      meta: {
        type: '首页信息'
      },
      children: [{
        path: 'swiper',
        name: 'swiper',
        component: () =>
          import( /* webpackChunkName: "Town" */ '@/views/TownIndex2/swiper'),
      },]
    },
    // 机构登录注册
    {
      path: '/Login',
      name: 'Login',
      component: () =>
        import( /* webpackChunkName: "Login" */ '@/views/Login'),
      redirect: '/Login/Login',
      meta: {
        type: 'login',
      },
      children: [{
        path: 'Login',
        name: 'Login',
        meta: {
          type: 'login',
        },
        component: () =>
          import( /* webpackChunkName: "Login" */ '@/views/Login/Login'),
      },

      {
        path: 'Registered',
        name: 'Registered',
        component: () =>
          import( /* webpackChunkName: "Registered" */ '@/views/Login/Registered'),
        meta: {
          type: 'login',
        },
      },
      {
        path: 'PassWordLogin',
        name: 'PassWordLogin',
        component: () =>
          import( /* webpackChunkName: "PassWordLogin" */ '@/views/Login/PassWordLogin'),
        meta: {
          type: 'login',
        },
      },
      {
        path: 'ResetPassword',
        name: 'ResetPassword',
        component: () =>
          import( /* webpackChunkName: "ResetPassword" */ '@/views/Login/ResetPassword'),
        meta: {
          type: 'login',
        },
      }
      ]
    },

    // 举报登录注册
    {
      path: '/reportLogin',
      name: 'ReportLogin',
      component: () =>
        import( /* webpackChunkName: "ReportLogin" */ '@/views/LoginReport'),
      redirect: '/reportLogin/Login',
      meta: {
        type: 'login',
      },
      children: [{
        path: 'Login',
        name: 'Login',
        meta: {
          type: 'login',
        },
        component: () =>
          import( /* webpackChunkName: "ReportLogin" */ '@/views/LoginReport/Login'),
      },

      {
        path: 'Registered',
        name: 'Registered',
        component: () =>
          import( /* webpackChunkName: "ReportLogin" */ '@/views/LoginReport/Registered'),
        meta: {
          type: 'login',
        },
      },
      {
        path: 'PassWordLogin',
        name: 'PassWordLogin',
        component: () =>
          import( /* webpackChunkName: "ReportLogin" */ '@/views/LoginReport/PassWordLogin'),
        meta: {
          type: 'login',
        },
      },
      {
        path: 'ResetPassword',
        name: 'ResetPassword',
        component: () =>
          import( /* webpackChunkName: "ReportLogin" */ '@/views/LoginReport/ResetPassword'),
        meta: {
          type: 'login',
        },
      }
      ]
    },

    // 首页 & 个人中心
    {
      path: '/UC',
      name: 'UserIndex',
      component: () =>
        import( /* webpackChunkName: "about" */ '@/views/User'),
      redirect: '/UC/User',
      children: [{
        path: 'User',
        name: 'User',
        component: () =>
          import( /* webpackChunkName: "User" */ '@/views/User/User')
      }, {
        path: 'Center',
        name: 'Center',
        component: () =>
          import( /* webpackChunkName: "User" */ '@/views/User/Center'),
        redirect: '/UC/Center/UserCenter',
        meta: {
          name: '个人中心',
          path: "/UC/Center/UserCenter"
        },
        children: [{
          path: 'UserCenter',
          name: 'UserCenter',
          component: () =>
            import( /* webpackChunkName: "User" */ '@/views/User/UserCenter')
        }, {
          path: 'CenterEdit',
          name: 'CenterEdit',
          component: () =>
            import( /* webpackChunkName: "User" */ '@/views/User/CenterEdit'),
          meta: {
            name: '编辑资料'
          }
        }, {
          path: 'PsdEdit',
          name: 'PsdEdit',
          component: () =>
            import( /* webpackChunkName: "User" */ '@/views/User/PsdEdit'),
          meta: {
            name: '修改密码'
          },
        }]
      }, {
        path: 'InfoCenter',
        name: 'InfoCenter',
        component: () =>
          import( /* webpackChunkName: "User" */ '@/views/User/InfoCenter'),
        meta: {
          name: '消息中心',
          path: "/Center/UserCenter"
        },
      },
      {
        path: 'InfoDetail',
        name: 'InfoDetail',
        component: () =>
          import( /* webpackChunkName: "User" */ '@/views/User/InfoDetail'),
        meta: {
          name: '消息详情',
          path: "/Center/UserCenter"
        },
      }
      ]
    },
    // 基金管理机构
    {
      path: '/FundManagement',
      name: 'FundManagement',
      component: () =>
        import( /* webpackChunkName: "FundManagement" */ '@/views/FundManagement'),
      meta: {
        name: '基金管理机构',
        path: '/FundManagement/FundList'
      },
      children: [{
        path: 'FundList',
        name: 'FundList',
        component: () =>
          import( /* webpackChunkName: "FundManagement" */ '@/views/FundManagement/FundList'),
        meta: {
          name: '机构列表',
        },
      }, {
        path: 'FundDetail',
        name: 'FundDetail',
        component: () =>
          import( /* webpackChunkName: "FundAgency" */ '@/views/FundManagement/FundDetail'),
        meta: {
          name: '私募基金管理机构详情',
          common: true
        },
      }, {
        path: 'NewAgency',
        name: 'NewAgency',
        component: () =>
          import( /* webpackChunkName: "FundManagement" */ '@/views/FundManagement/NewAgency'),
        meta: {
          name: '私募基金管理机构',
          common: true
        }
      }, {
        path: 'UpdataAgency',
        name: 'UpdataAgency',
        component: () =>
          import( /* webpackChunkName: "FundManagement" */ '@/views/FundManagement/UpdataAgency'),
        meta: {
          name: '变更私募基金管理机构'
        }
      }, {
        path: 'AddAgency',
        name: 'AddAgency',
        component: () =>
          import( /* webpackChunkName: "FundManagement" */ '@/views/FundManagement/AddAgency'),
        meta: {
          name: '迁入私募基金管理机构'
        }
      }]
    },
    // 基金机构
    {
      path: '/FundAgency',
      name: 'FundAgency',
      component: () =>
        import( /* webpackChunkName: "FundAgency" */ '@/views/FundAgency'),
      meta: {
        name: '入驻申请',
        path: '/FundAgency/FundList'
      },
      children: [{
        path: 'FundList',
        name: 'FundList',
        component: () =>
          import( /* webpackChunkName: "FundAgency" */ '@/views/FundAgency/FundList'),
        meta: {
          name: '机构列表'
        },
      }, {
        path: 'FundDetail',
        name: 'FundDetail',
        component: () =>
          import( /* webpackChunkName: "FundAgency" */ '@/views/FundAgency/FundDetail'),
        meta: {
          name: '入驻申请详情',
          common: true
        },
      }, {
        path: 'Agency',
        name: 'Agency',
        component: () =>
          import( /* webpackChunkName: "FundAgency" */ '@/views/FundAgency/Agency'),
        meta: {
          name: '入驻申请',
          common: true
        }
      }]
    },
    // 审核进度
    {
      path: '/Audit',
      name: 'Audit',
      component: () =>
        import( /* webpackChunkName: "Audit" */ '@/views/Audit'),
      redirect: '/Audit/List',
      meta: {
        name: '审核进度',
        path: '/Audit/List'
      },
      children: [{
        path: 'List',
        name: 'List',
        component: () =>
          import( /* webpackChunkName: "Audit" */ '@/views/Audit/List')
      }, {
        path: 'FundManagerDetail',
        name: 'FundManagerDetail',
        component: () =>
          import( /* webpackChunkName: "Audit" */ '@/views/Audit/components/FundManagerDetail'),
        meta: {
          name: '入驻申请详情',
          common: true
        },
      }, {
        path: 'FundDetail',
        name: 'FundDetail',
        component: () =>
          import( /* webpackChunkName: "Audit" */ '@/views/Audit/components/FundDetail'),
        meta: {
          name: '私募基金管理机构详情',
          common: true
        },
      },]
    },
    // 季报管理
    {
      path: '/QuaReport',
      name: 'QuaReport',
      component: () =>
        import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport'),
      meta: {
        name: '季报管理',
        path: '/QuaReport/Record'
      },
      children: [{
        path: 'Record',
        name: 'Record',
        component: () =>
          import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport/Record'),
        meta: {
          name: '季报记录'
        }
      }, {
        path: 'AgencyMan',
        name: 'AgencyMan',
        component: () =>
          import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport/AgencyMan'),
        meta: {
          name: '填写基金管理机构季报'
        }
      }, {
        path: 'MgrGQ',
        name: 'MgrGQ',
        component: () =>
          import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport/MgrGQ'),
        meta: {
          name: '填写基金管理机构季报'
        }
      }, {
        path: 'Agency',
        name: 'Agency',
        component: () =>
          import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport/Agency'),
        meta: {
          name: '填写基金机构季报'
        }
      }, {
        path: 'managerDetail',
        name: 'managerDetail',
        component: () =>
          import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport/managerDetail'),
        meta: {
          name: '基金管理机构季报详情'
        }
      }, {
        path: 'agencyDetail',
        name: 'agencyDetail',
        component: () =>
          import( /* webpackChunkName: "QuaReport" */ '@/views/QuaReport/agencyDetail'),
        meta: {
          name: '基金机构季报详情'
        }
      }]
    },
    // 小镇服务
    {
      path: '/Town',
      name: 'Town',
      component: () =>
        import( /* webpackChunkName: "Town" */ '@/views/Town'),
      redirect: '/Town/List',
      meta: {
        name: '小镇服务'
      },
      children: [{
        path: 'Affairs',
        name: 'Affairs',
        component: () =>
          import( /* webpackChunkName: "Town" */ '@/views/Town/Affairs'),
        meta: {
          name: '登记注册服务'
        }
      }, {
        path: 'Fund',
        name: 'fund',
        component: () =>
          import( /* webpackChunkName: "Town" */ '@/views/Town/Fund'),
        meta: {
          name: '基金业务服务'
        }
      }, {
        path: 'Laws',
        name: 'Laws',
        component: () =>
          import( /* webpackChunkName: "Town" */ '@/views/Town/Laws'),
        meta: {
          name: '政策法规'
        }
      }, {
        path: 'LawsDetail',
        name: 'LawsDetail',
        component: () =>
          import( /* webpackChunkName: "Town" */ '@/views/Town/LawsDetail'),
        meta: {
          name: '政策法规详情'
        }
      }]
    },
    // 信息公示
    {
      path: '/Publicity',
      name: 'Publicity',
      component: () =>
        import( /* webpackChunkName: "Audit" */ '@/views/Publicity'),
      meta: {
        name: '信息公示',
        type: "WR"
      },
    },
    {
      path: '/ReportPlatform',
      name: 'ReportPlatform',
      component: () =>
        import( /* webpackChunkName: "ReportPlatform" */ '@/views/ReportPlatform'),
      redirect: '/ReportPlatform/ReportList',
      meta: {
        name: '线上举报',
        path: "/ReportPlatform/ReportList",
        type: "WR"
      },
      children: [{
        path: 'ReportList',
        name: 'ReportList',
        meta: {
          name: '举报列表',
          type: "WR"
        },
        component: () =>
          import( /* webpackChunkName: "ReportList" */ '@/views/ReportPlatform/ReportList'),
      },
      {
        path: 'InitiateReport',
        name: 'InitiateReport',
        meta: {
          name: '发起举报',
          type: "WR"
        },
        component: () =>
          import( /* webpackChunkName: "InitiateReport" */ '@/views/ReportPlatform/InitiateReport'),
      },
      {
        path: 'Description',
        name: 'Description',
        meta: {
          name: '举报说明',
          type: "WR"
        },
        component: () =>
          import( /* webpackChunkName: "Description" */ '@/views/ReportPlatform/Description'),
      },
      {
        path: 'ToProcessed',
        name: 'ToProcessed',
        meta: {
          name: '举报详情',
          type: "WR"
        },
        component: () =>
          import( /* webpackChunkName: "ToProcessed" */ '@/views/ReportPlatform/ToProcessed'),
      },
      {
        path: 'Processing',
        name: 'Processing',
        meta: {
          name: '举报处理',
          type: "WR"
        },
        component: () =>
          import( /* webpackChunkName: "Processing" */ '@/views/ReportPlatform/Processing'),
      },
      {
        path: 'Processed',
        name: 'Processed',
        meta: {
          name: '举报处理',
          type: "WR"
        },
        component: () =>
          import( /* webpackChunkName: "Processed" */ '@/views/ReportPlatform/Processed'),
      },

      ]

    }

  ]
})